import React from 'react';
import Container from '../../../components/UI/Container';
import { enFr } from '../../../utils';
import { openCalendarModal } from '../../../utils/modal-helpers.jsx';
import EngagementWrapper from './engagement.style';

const EngagementModel = () => {
  const steps = [
    {
      number: '01',
      title: enFr('Discovery Call', 'Appel de découverte'),
      description: enFr(
        'A focused conversation to understand your business, your challenges, and where technology can make a measurable difference.',
        'Une conversation ciblée pour comprendre votre entreprise, vos défis et où la technologie peut faire une différence mesurable.'
      ),
    },
    {
      number: '02',
      title: enFr('Scoped Proposal', 'Proposition cadrée'),
      description: enFr(
        'A clear, detailed proposal outlining the approach, deliverables, timeline, and investment. No ambiguity.',
        'Une proposition claire et détaillée décrivant l\u2019approche, les livrables, le calendrier et l\u2019investissement. Sans ambiguïté.'
      ),
    },
    {
      number: '03',
      title: enFr('Engagement', 'Engagement'),
      description: enFr(
        'Execution through a fixed project, retainer, or workshop format, whichever fits your situation best.',
        'Exécution à travers un projet fixe, un mandat ou un format d\u2019atelier, selon ce qui convient le mieux à votre situation.'
      ),
    },
    {
      number: '04',
      title: enFr('Clear Deliverables', 'Livrables clairs'),
      description: enFr(
        'Tangible outputs at every stage: strategy documents, working systems, trained teams, and measurable results.',
        'Des résultats tangibles à chaque étape : documents stratégiques, systèmes fonctionnels, équipes formées et résultats mesurables.'
      ),
    },
  ];

  const tiers = [
    {
      name: enFr('Strategy Sprint', 'Sprint stratégique'),
      description: enFr(
        'Rapid assessment and roadmap for organizations exploring new software builds or AI adoption.',
        'Évaluation rapide et feuille de route pour les organisations explorant de nouveaux développements logiciels ou l\u2019adoption de l\u2019IA.'
      ),
      duration: enFr('2\u20134 weeks', '2\u20134 semaines'),
    },
    {
      name: enFr('Implementation Project', 'Projet d\u2019implémentation'),
      description: enFr(
        'Scoped development, integration, and automation projects with defined deliverables.',
        'Projets de développement, d\u2019intégration et d\u2019automatisation cadrés avec des livrables définis.'
      ),
      duration: enFr('4\u201312 weeks', '4\u201312 semaines'),
    },
    {
      name: enFr('Advisory Retainer', 'Mandat consultatif'),
      description: enFr(
        'Ongoing strategic guidance and decision support for leadership teams.',
        'Accompagnement stratégique continu et aide à la décision pour les équipes de direction.'
      ),
      duration: enFr('Monthly', 'Mensuel'),
    },
  ];

  return (
    <EngagementWrapper id="engagement">
      <Container>
        <div className="section-header">
          <h2>{enFr('How We Work', 'Notre approche')}</h2>
          <p className="section-subtitle">
            {enFr(
              'Consulting that starts with an in-person or virtual meeting, then moves to a structured, transparent remote process through to final deliverable.',
              'Une consultation qui débute par une rencontre en personne ou virtuelle, puis se poursuit par un processus distant structuré et transparent jusqu\u2019au livrable final.'
            )}
          </p>
        </div>

        <div className="steps-grid">
          {steps.map((step, index) => (
            <div className="step-card" key={index}>
              <span className="step-number">{step.number}</span>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>

        <div className="tiers-section">
          <h3 className="tiers-title">
            {enFr('Engagement Formats', 'Formats d\u2019engagement')}
          </h3>
          <div className="tiers-grid">
            {tiers.map((tier, index) => (
              <div className="tier-card" key={index}>
                <h4>{tier.name}</h4>
                <p>{tier.description}</p>
                <span className="tier-duration">{tier.duration}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="engagement-cta">
          <button onClick={openCalendarModal} type="button">
            {enFr('Schedule a Discovery Call', 'Planifier un appel de découverte')}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </button>
        </div>
      </Container>
    </EngagementWrapper>
  );
};

export default EngagementModel;
